import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import getScenarioStore from '../selectors/getScenarioStore';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { onSearchScopeOptionSelected } from '../actions/onSearchScopeOptionSelected';
import { onSearchScopeButtonClicked } from '../actions/onSearchScopeButtonClicked';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';
import { SearchScopeMenuLabel } from './SearchScopePicker.locstring.json';
import loc from 'owa-localize';
import { SEARCH_SCOPE_SWITCHER_ID, SEARCH_SCOPE_SWITCHER_WRAPPER_ID } from '../searchConstants';

const styles = require('./SearchScopePicker.scss');

export interface SearchScopeSwitcherProps {
    selectedSearchScope: () => string;
    searchScopes: () => IContextualMenuItem[];
    onSearchScopeSelected?: (ev?: any, dismissAll?: boolean) => void;
    scenarioId: SearchScenarioId;
}

export default observer(function SearchScopeSwitcher(props: SearchScopeSwitcherProps) {
    const store = getScenarioStore(props.scenarioId);
    const isScopePickerVisible = store.isScopePickerVisible;
    const newIsScopePickerVisible = !isScopePickerVisible;

    const onScopeButtonClick = React.useCallback(() => {
        onSearchScopeButtonClicked(newIsScopePickerVisible, props.scenarioId);
    }, [newIsScopePickerVisible]);

    const onMenuItemClick = React.useCallback(
        (ev?: React.MouseEvent<HTMLElement>, item?: IContextualMenuItem) => {
            const { key } = item;

            onSearchScopeOptionSelected(key, props.scenarioId);
            props.onSearchScopeSelected(ev, true);
        },
        []
    );

    const selectedSearchScope = props.selectedSearchScope();
    if (!selectedSearchScope) {
        return null;
    }

    const onRenderText = () => {
        return <div className={styles.searchScopeText}>{selectedSearchScope}</div>;
    };

    const items: IContextualMenuItem[] = props.searchScopes();
    //  For Firefox on Mac, when user clicks on search scope the focus disappears from the search box.
    //  It does not recognize the search scope switcher id, so adding a wrapper div around it and verifying the component by parent div instead
    return (
        <div
            tabIndex={-1}
            id={SEARCH_SCOPE_SWITCHER_WRAPPER_ID}
            className={styles.searchScopeWrapper}>
            <PrimaryButton
                id={SEARCH_SCOPE_SWITCHER_ID}
                className={styles.searchScopeNeutral}
                onRenderText={onRenderText}
                styles={{
                    flexContainer: styles.flexContainer,
                }}
                onMenuClick={onScopeButtonClick}
                aria-label={loc(SearchScopeMenuLabel)}
                menuProps={{
                    items: items,
                    directionalHintFixed: true,
                    onItemClick: onMenuItemClick,
                    calloutProps: { calloutMaxHeight: 500, calloutMaxWidth: 200 },
                    gapSpace: 1,
                }}
            />
        </div>
    );
});
